"use strict";
exports.__esModule = true;
exports.SIZES = void 0;
exports.SIZES = {
    huge: 'h-14 min-h-14 md:h-16 md:min-h-16 text-m-lg sm:text-t-lg md:text-d-lg !px-3.5 md:!px-4 gap-x-3',
    large: 'h-12 min-h-12 md:h-14 md:min-h-14 text-m-base sm:text-d-base md:text-t-lg !px-3 md:!px-3.5 gap-x-3',
    medium: 'h-10 min-h-10 md:h-12 md:min-h-12 text-m-sm sm:text-d-sm md:text-d-base !px-2 md:!px-3 gap-x-1.5',
    small: 'h-8 min-h-8 md:h-10 md:min-h-10 text-m-xs sm:text-t-xs md:text-d-sm !px-2 md:!px-2.5 gap-x-1',
    tiny: 'h-6 min-h-6 md:h-8 md:min-h-8 text-m-xs sm:text-t-xs md:text-d-xs !px-1.5 md:!px-2 gap-x-0.5'
};
//# sourceMappingURL=stepper.style.js.map